<div class="time-list" [ngClass]="{'multi-line': isMultiLine}">
    <div class="schedule-time"
        *ngFor="let time of times; let isLast = last">
        <finder-schedule-time [separator]="separator" [time]="time"></finder-schedule-time>
        <span *ngIf="!isLast && time.startTime === time.endTime">,&nbsp;</span>
        <span *ngIf="!isLast && times.length === 2 && time.startTime !== time.endTime">&nbsp;{{separatorLabel}}&nbsp;</span>
    </div>
</div>
